import PanelIMG from "../images/panel/PanelImage.png";
import expert_1 from "../images/panel/expert_1.png"; // 김도원
import expert_2 from "../images/panel/expert_2.png"; // 이지현
import expert_3 from "../images/panel/expert_3.png"; // 박서연
import expert_4 from "../images/panel/expert_4.png"; // 장석훈
import expert_5 from "../images/panel/expert_5.png"; // 윤재민
import expert_6 from "../images/panel/expert_6.png"; // 김세준
import expert_7 from "../images/panel/expert_7.png";
import expert_8 from "../images/panel/expert_8.png"
import expert_9 from "../images/panel/expert_9.png";
import expert_10 from "../images/panel/expert_10.png";
import expert_0 from "../images/panel/expert_0.png"; // 기본

const panelimages = {
  PanelIMG,
  expert_0,
  expert_1,
  expert_2,
  expert_3,
  expert_4,
  expert_5,
  expert_6,
  expert_7,
  expert_8,
  expert_9,
  expert_10,
};

export default panelimages;
